import { render, staticRenderFns } from "./estudioSkeletonComponent.vue?vue&type=template&id=5aec795d&"
var script = {}
import style0 from "./estudioSkeletonComponent.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports